// User-friendly labels for backend tool names (tool_call_completed rows).
export const toolNameMap: Record<string, string> = {
  get_relevant_nodes: 'Finding relevant nodes',
  get_node_details: 'Getting node configuration details',
  list_available_actions: 'Listing available actions',
  list_action_providers: 'Checking action providers',
  get_action_details: 'Getting action configuration',
  add_node_and_edge_with_progress: 'Adding workflow node',
  update_node_config_with_progress: 'Updating node configuration',
  add_edge_with_progress: 'Connecting workflow nodes',
  generate_multiple_uuids: 'Generating unique identifiers',
  get_mcp_tool_details: 'Getting integration details',
}
